import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VegaComponent } from './components/vega/vega.component';
import { SharedModule } from '@kildenshared/shared.module';

@NgModule({
  imports: [CommonModule, SharedModule, VegaComponent],
})
export class ProjectVegaModule {}
